module.exports = __webpack_public_path__ + "fonts/b8ecef1f4c0e42d365ec8626607e1406.woff2";